<template>
<ProjectStructureDetails>
  <template #header>
    <v-btn
      :style="`
        position: absolute;
        ${['trains', 'taktareas'].includes(element.type)?'right: 3px':''}
      `"
      icon
      @click="$router.push({
        name: 'ProjectStructure'
        })"
      >
      <v-icon>{{['trains', 'taktareas'].includes(element.type)?'keyboard_arrow_right':'keyboard_arrow_left'}}</v-icon>
    </v-btn>
    <div style="margin-left: 30vw; transform: translateX(-50%)">{{element.name}}</div>
  </template>
  <template #body>
    <transition name="dialog_slide">
      <router-view style="z-index: 20"/>
    </transition>
    <ProjectStructureWidget>
      <template #header>
        <div class="color-white-09">{{$t('Project.Structure.Detail.Attributes')}}</div>
      </template>
      <template #body>
        <StandardDataField
          text_color="rgba(255,255,255,0.8)" color="grey darken-4"
          :value="element.name"
          @changeValue="updateUObject({
              url: [
                {[element.type]: element.id},
              ],
              url_prefix: `/projects/${project_id}/projectstructure`,
              update: {
                name: $event
              }
            })"
          >
          <template #prepend-slot>
            <div class="mr-1">{{$t('Project.Structure.Detail.Name')}}: </div>
          </template>
        </StandardDataField>
      </template>
    </ProjectStructureWidget>
    <ProjectStructureWidget
    v-if="element.type === 'elements'"
    plan="true"
    >
    <template #header>
      <div class="color-white-09">{{$t('Project.Structure.Detail.Location')}}</div>
    </template>
    <template #body>
      <template v-if="element.locations.length !== 0">
        <template v-for="location in getUDObjects({type: 'locations', ids: element.locations})">
          <canvas
          :key="`${location.id}_pdf`"
          id="plan_details_pdf"
          style="position: absolute;"
          />
          <canvas
          :key="`${location.id}_canvas`"
          id="plan_details_canvas"
          class="cursor-pointer"
          style="position: absolute; top: 0px; left: 0px"
          @click="$router.push({
            name: 'ProjectStructurePlans',
            params: {
              plan_id: location.plan_id,
              spatialunits_location: {
                plan_parent_type: getUDObjectsFiltered({types: ['sites', 'spatialzones', 'buildings', 'storeys', 'spaces'], search: {plans: location.plan_id}})[0].type,
                plan_parent_id: getUDObjectsFiltered({types: ['sites', 'spatialzones', 'buildings', 'storeys', 'spaces'], search: {plans: location.plan_id}})[0].id,
              }
            }
            })"
            />
          </template>
        </template>
        <template v-else>
          <transition name="dialog_slide">
            <ProjectStructureWidgetOverlay
            v-if="manage_location"
            location="true"
            >
            <TFlex
            width="100%"
            justify_content="space-between"
            align_items="center"
            >
            <div style="color: rgba(255,255,255,0.8)">Select Floor Plan:</div>
            <v-btn
            icon
            class="grey darken-4"
            @click="manage_location = !manage_location"
            >
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </TFlex>
        <StandardDataField
        style="cursor: pointer !important"
        v-for="floor_plan in getParentsFloorPlans({type: element.parent.type, id: element.parent.id})"
        :key="floor_plan.element.id"
        text_color="rgba(255,255,255,0.8)" color="grey darken-4"
        :value="floor_plan.element.name"
        readonly="true"
        @click.native="$router.push({
          name: 'ProjectStructurePlans',
          params: {
            plan_id: floor_plan.plan.id,
            spatialunits_location: {
              plan_parent_type: floor_plan.element.type,
              plan_parent_id: floor_plan.element.id,
            }
          }
        })"
        >
      </StandardDataField>
    </ProjectStructureWidgetOverlay>
  </transition>
  <v-btn
  style="left: 50%; top: 50%; transform: translate(-50%,-50%);"
  height="80"
  width="80"
  @click="manage_location = !manage_location"
  >
  <v-icon size="45">add</v-icon>
</v-btn>
</template>
</template>
    </ProjectStructureWidget>
    <ProjectStructureWidget v-if="element.type === 'elements'">
      <template #header>
        <div class="color-white-09">{{$t('Project.Structure.Detail.Elements')}}</div>
      </template>
      <template #body>
      </template>
    </ProjectStructureWidget>
    <ProjectStructureWidget v-if="element.type !== 'elements'" plan="true">
      <template #header>
        <div class="color-white-09">{{element.type === 'elements'?'Detail Plans':'Floor Plan'}}</div>
      </template>
      <template #body>
        <!-- <StandardDataField
        v-for="plan in getUDObjects({type: 'plans', ids: element.plans})"
        :key="plan.id"
        text_color="rgba(255,255,255,0.8)"
        color="grey darken-4"
        :value="plan.name"
        readonly="true"
        >
        </StandardDataField> -->
        <template v-if="element.plans.length !== 0">
          <transition name="dialog_slide">
            <ProjectStructureWidgetOverlay
              v-if="manage_floor_plan"
              >
            <v-btn
              @click="$refs.uploadPlan.click()"
              >
              {{$t('Buttons.Replace')}}
            </v-btn>
            <StandardDeleteButtonLarge
              style="width: 100px"
              class="red lighten-1"
              confirm_text="sure?"
              @clickDelete="
              deleteFloorPlanLocations(element.plans[0]).then(() => {
                deleteUDObject({
                  url: [
                  {[element.type]: element.id},
                  {plans: element.plans[0]}
                  ]
                  })
                  })"
                  >
                  {{$t('Buttons.Delete')}}
              </StandardDeleteButtonLarge>
              <v-btn
                icon
                class="grey darken-4"
                @click="manage_floor_plan = !manage_floor_plan"
                >
                <v-icon>keyboard_arrow_down</v-icon>
              </v-btn>
            </ProjectStructureWidgetOverlay>
          </transition>
          <canvas
            id="plan_details_floor_plan_pdf"
            style="position: absolute;"
          />
          <canvas
            id="plan_details_floor_plan_canvas"
            class="cursor-pointer"
            style="position: absolute; top: 0px; left: 0px"
            @click="$router.push({
              name: 'ProjectStructurePlans',
              params: {
                plan_id: element.plans[0]
              }
            })"
          />
          <v-btn
            icon
            class="grey darken-4"
            style="position: absolute; top: 3px; right: 3px"
            @click="manage_floor_plan = !manage_floor_plan"
            >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            style="left: 50%; top: 50%; transform: translate(-50%,-50%);"
            height="80"
            width="80"
            @click="element.type !== 'elements'?$refs.uploadPlan.click():''"
            >
            <v-icon size="45">add</v-icon>
          </v-btn>
        </template>
        <input
        v-show="false"
        ref="uploadPlan"
        type="file"
        accept=".pdf"
        @change="selectFloorPlan($refs.uploadPlan.files[0])"
        >
        <!-- <StandardDataField
          v-else
          text_color="rgba(255,255,255,0.8)"
          color="grey darken-4"
          icon="add"
          value="Add Plan"
          :readonly="true"
          @click.native="
          createUDObject({
            url: [
            {[element.type]: element.id},
            {plans: ''},
            {showWithEntitiesNormalized: ''}
            ],
            resp_data: {
              plans: [
              {
                id: -1,
                name: 'New Plan',
                plan_url: '',
                reference_x: 25,
                reference_y: 25,
                scale_x_1: 75,
                scale_y_1: 25,
                scale_x_2: 275,
                scale_y_2: 25,
                pixcel_per_length: 20,
              }
              ]
            }
          }).then((id) =>{
            $router.push({
              name: 'ProjectStructurePlans',
              params: {
                plan_id: id
              }
            })
          })"
          /> -->
      </template>
    </ProjectStructureWidget>
    <ProjectStructureWidget v-else>
      <template #header>
        <div class="color-white-09">{{$t('Project.Structure.Detail.Workpackages')}}</div>
      </template>
      <template #body>
        <template>
          <TFlex height="36px">
            <v-btn
              icon
              class="grey darken-4"
              style="position: absolute; top: 3px; right: 3px"
              @click="manage_workpackages = !manage_workpackages"
              >
              <v-icon>add</v-icon>
            </v-btn>
          </TFlex>
          <TFlex>
            <WorkPackage
              style="cursor: pointer"
              v-for="(workpackage, index) in getUObjects({type: 'testworkpackages', ids: element.workpackages})"
              :key="workpackage.id"
              :color="workpackage.color"
              :token="workpackage.token"
              :icon="workpackage.icon"
              @click.native="
                let copy = element.workpackages.slice();
                copy.splice(index,1);
                updateUDObject({
                    url: [
                      {elements: element.id}
                    ],
                    update: {
                      workpackages: copy
                    }
                  })"
            />
          </TFlex>
          <transition name="dialog_slide">
            <ProjectStructureWidgetOverlay
              location="true"
              v-if="manage_workpackages"
              >
              <TFlex>
                <v-tabs
                  height="36px"
                  fixed-tabs
                  >
                  <v-tab>{{$t('Project.Structure.Detail.Workpackages')}}</v-tab>
                  <v-tab>{{$t('Project.Structure.Detail.Sequences')}}</v-tab>
                </v-tabs>
                <v-btn
                  icon
                  class="grey darken-4"
                  @click="manage_workpackages = !manage_workpackages"
                  >
                  <v-icon>keyboard_arrow_down</v-icon>
                </v-btn>
              </TFlex>
              <TFlex class="mt-2">
                <WorkPackage
                  style="cursor: pointer;"
                  v-for="workpackage in getUObjects({type: 'testworkpackages'})"
                  :key="workpackage.id"
                  :color="workpackage.color"
                  :token="workpackage.token"
                  :icon="workpackage.icon"
                  @click.native="!element.workpackages.includes(workpackage.id)?
                    updateUDObject({
                        url: [
                          {elements: element.id}
                        ],
                        update: {
                          workpackages: element.workpackages.concat([workpackage.id])
                        }
                      })
                    :''"
                  >
                  <template #workpackage>
                    <StandardBadge v-if="element.workpackages.includes(workpackage.id)" color="green" icon="done" />
                  </template>
                </WorkPackage>
              </TFlex>
            </ProjectStructureWidgetOverlay>
          </transition>
        </template>
      </template>
    </ProjectStructureWidget>
  </template>
</ProjectStructureDetails>
</template>
<script>
  import store from '@/store/index';
  import { ProjectStructureMixin } from '@/mixins/ProjectStructure.mixin.js'
  export default {
    mixins: [
      ProjectStructureMixin,
    ],
    data: () => ({

    }),
    computed: {
      project_id() {
        return parseInt(this.$route.params.project_id);
      },
      element() {
        return store.getters['UltraDev/getUDObject']({
          type: this.$route.params.type,
          id: this.$route.params.structure_id
        })
      }
    },
  }
</script>
